<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Tìm kiếm người khuyết tật</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="ma">Mã định danh</nz-form-label>
          <nz-form-control nzSpan="24">
            <input nz-input [(ngModel)]="commonFilter.StudentCode" [ngModelOptions]="{standalone: true}"
              [placeholder]="'Nhập mã định danh...'" [ngModelOptions]="{standalone: true}">
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Họ tên</nz-form-label>
          <nz-form-control nzSpan="24">
            <input type="text" nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}"
              [placeholder]="'Nhập họ tên...'" [ngModelOptions]="{standalone: true}">
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="YearOfBirth">Năm sinh</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-input-number [(ngModel)]="commonFilter.YearOfBirth" [nzMin]="1970" [nzMax]="9999" [nzStep]="1"
              nzPlaceHolder="Nhập năm sinh" [ngModelOptions]="{standalone: true}">
            </nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Giới tính</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
              <label nz-radio nzValue="-5">Tất cả</label>
              <label nz-radio nzValue="1">Nam</label>
              <label nz-radio nzValue="0">Nữ</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <ng-container *ngIf="isCollapse == false">

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Dạng tật</nz-form-label>
            <asc-autocomplete [ascModel]="TypeOfDisabilityControl" (ascModelChange)="changeTypeOfDisability($event)"
              [placeholder]="'Chọn dạng...'" [getListAC]="getTypeOfDisabilityACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Mức độ khuyết tật</nz-form-label>
            <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevel($event)"
              [placeholder]="'Chọn mức độ khuyết tật...'" [getListAC]="getLevelACFn"></asc-autocomplete>
          </nz-form-item>
        </div>

      </ng-container>
      <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">hi</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          (click)="toggleCollapse()" nz-tooltip><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon nzType="clear"
              nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="listStudent"
      [nzFrontPagination]="false" nzSize="small" [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full"
      [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzLoading]="loading">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft>STT</th>
          <th nzLeft nzWidth="115px">Mã định danh</th>
          <th nzLeft nzWidth="180px">Họ tên</th>
          <th nzWidth="50px">Giới tính</th>
          <th nzWidth="70px">Năm sinh</th>
          <th nzWidth="250px">Cơ sở giáo dục</th>
          <th nzWidth="200px">Dạng tật</th>
          <th nzWidth="100px">Mức độ khuyết tật</th>
          <th nzRight nzWidth="60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{item.studentCode}}</td>
          <td nzLeft>{{item.fullName}}</td>
          <td>{{item.gender | gender}}</td>
          <td>{{item.yearOfBirth }}</td>
          <td>{{item.eatosName}}</td>
          <td>{{item.typeOfDisabilityName}}</td>
          <td>{{item.levelName}}</td>
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block">
              <nz-space-item>
                <button nz-button nzType="primary" (click)="ChooseData(item)">Chọn</button>
              </nz-space-item>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ total }} </ng-template>

<div *nzModalFooter>
  <div class="card-footer text-right">
    <button nz-button (click)="close()">Đóng</button>&nbsp;

  </div>
</div>
